import React from "react";

export const LoadingButton = ({ value, submit, processing, buttonClass }) => {
	return (
		<button value={value} className={buttonClass} onClick={( e ) => submit()} type="button">
			<ButtonInner processing={processing} value={value} />
		</button>
	)
}


export const LoadingFormButton = ({ value, processing, buttonClass }) => {
	return (
		<button value={value} className={buttonClass} type="submit">
			<ButtonInner processing={processing} value={value} />
		</button>
	)
}

const ButtonInner = ({ processing, value }) => {
	
	if( processing ) {
		return <><div className="loader small mg-r-sm"></div> Loading...</>
	} else {
		return <>{value}<span className="icon icon-arrow-right icon-l white right"></span></>
	}
}
